import React, { FC } from 'react';
import { Button, Modal } from '@investoro/core';
import styled from 'styled-components';
import { Platform } from 'utils/hooks/usePlatform';

const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 50px;
    padding: 60px;
    color: var(--color-var);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
    border-radius: var(--box-border-radius);

    p {
        text-align: center;
    }


    @media (max-width: 600px) {
        padding: 80px 20px;
    }
  
`;

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

interface Props {
    isOpen: boolean;
    platform: Platform;
    onClose: () => void;
    isCritical?: boolean;
}

const VersionAppPopup: FC<Props> = ({ isOpen, onClose, isCritical, platform }) => {
    if (!isOpen) return null;
    const link = platform === Platform.Android ? 'https://play.google.com/store/apps/details?id=com.investoro.app' : 'https://apps.apple.com/pl/app/investoro/id6740319885';

    const additionalText = isCritical ? 'Aby korzystać z aplikacji, musisz zaktualizować ją do najnowszej wersji.' : 'Zalecamy aktualizację aplikacji do najnowszej wersji, aby korzystać z najnowszych funkcji i poprawek bezpieczeństwa.';

    return (
        <Modal
            isOpen={isOpen}
            onClose={() => isCritical ? () => {} : onClose()}
            centeredContent
            strictContentHeight
            overflowing
            withoutCloseButton={isCritical}
        >
            <ModalContent>
                <h1>Dostępna nowa wersja aplikacji</h1>
                <p>{additionalText}</p>
                <ButtonContainer>
                    <Button onClick={() => {
                        window.location.href = link;
                        onClose();
                    }}>
                        Aktualizuj
                    </Button>

                    {!isCritical && <Button>Anuluj</Button>}
                </ButtonContainer>

            </ModalContent>
        </Modal>
    );
};

export default VersionAppPopup;
